// import React, { useRef } from 'react';
// import { Button, Carousel, Image, Typography } from 'antd';
// import { LeftOutlined, RightOutlined, ShoppingOutlined } from '@ant-design/icons';
// import { categories } from 'data/dummydata';
// import { Link } from 'react-router-dom';

// const { Title } = Typography;

// const CustomArrow = ({ direction, onClick }) => (
//     <Button
//         type={direction === 'next' ? "primary" : "default"}
//         shape="square"
//         icon={direction === 'next' ? <RightOutlined /> : <LeftOutlined />}
//         onClick={onClick}
//         className={`custom-arrow ${direction}-arrow`}
//     />
// );

// export default function Reviews() {
//     const categoriesArray = Object.values(categories);
//     const carouselRef = useRef();

//     const nextSlide = () => carouselRef.current.next();
//     const prevSlide = () => carouselRef.current.prev();

//     const settings = {
//         dots: false,
//         infinite: false,
//         speed: 500,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         responsive: [
//             { breakpoint: 1400, settings: { slidesToShow: 3 } },
//             { breakpoint: 992, settings: { slidesToShow: 2 } },
//             { breakpoint: 768, settings: { slidesToShow: 1 } },
//             { breakpoint: 576, settings: { slidesToShow: 1 } },
//         ],
//     };

//     return (
//         <section className="bg-light py-5">
//             <div className="container categories-section">
//                 <div className="d-flex justify-content-between align-items-center mb-4 py-5">
//     <Title level={2} className="mb-0">
//         What our Customer say's
//     </Title>
//     <div className="arrow-container">
//         <CustomArrow direction="prev" onClick={prevSlide} />
//         <CustomArrow direction="next" onClick={nextSlide} />
//     </div>
// </div>
//                 <Carousel ref={carouselRef} {...settings}>
//                     {categoriesArray.map((category, index) => (
//                         <div key={index} className="px-2">
//                             <div className="category-image-container">
//                                 <Image src={category.imageUrl} alt={category.name} className="category-image" width="100%" height={350} preview={false} />
//                                 <div className="category-overlay">
//                                     <Link className='w-50 mb-5 fw-medium' to={`/products?category=${encodeURIComponent(category.name)}`}>
//                                         <Button type="primary" className="w-100 bg-white fw-medium text-primary" size="large">
//                                             {category.name}
//                                         </Button>
//                                     </Link>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </Carousel>
//             </div>
//         </section>
//     );
// }

import React, { useRef } from 'react';
import { Button, Carousel, Avatar, Typography, Rate } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const CustomArrow = ({ direction, onClick }) => (
    <Button
        type={direction === 'next' ? "primary" : "default"}
        shape="square"
        icon={direction === 'next' ? <RightOutlined /> : <LeftOutlined />}
        onClick={onClick}
        className={`custom-arrow ${direction}-arrow`}
    />
);

// Dummy data for user reviews
const userReviews = [
    { name: "John Doe", avatar: "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png", rating: 5, desigination: "developer", review: "Excellent product! It exceeded my expectations in every way.", },
    { name: "Jane Smith", avatar: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png", rating: 4, desigination: "developer", review: "Great quality and fast shipping. Would definitely recommend!", },
    { name: "Mike Johnson", avatar: "https://joeschmoe.io/api/v1/random", rating: 5, desigination: "developer", review: "Outstanding customer service and top-notch product. Very satisfied!", },
    { name: "Emily Brown", avatar: "https://joeschmoe.io/api/v1/jess", rating: 4, desigination: "developer", review: "Good value for money. The product is durable and well-designed.", }
];

export default function Reviews() {
    const carouselRef = useRef();

    const nextSlide = () => carouselRef.current.next();
    const prevSlide = () => carouselRef.current.prev();

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1400, settings: { slidesToShow: 3 } },
            { breakpoint: 992, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <section className="bg-light py-5">
            <div className="container categories-section">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <Title level={2} className="mb-0">
                        What our Customer say's
                    </Title>
                    <div className="arrow-container">
                        <CustomArrow direction="prev" onClick={prevSlide} />
                        <CustomArrow direction="next" onClick={nextSlide} />
                    </div>
                </div>
                <Carousel ref={carouselRef} {...settings} className='my-4'>
                    {userReviews.map((review, index) => (
                        <div key={index} className="px-3 py-4">
                            <div className="bg-white p-4 rounded border shadow h-100">
                                <Rate disabled defaultValue={review.rating} />
                                <Paragraph className="mb-0 text-muted mt-3">
                                    "{review.review}"
                                </Paragraph>
                                <div className="d-flex align-items-center m-3 ">
                                    <Avatar src={review.avatar} size={64} />
                                    <div className="ms-3">
                                        <Title level={4} className="mb-0">{review.name}</Title>
                                        <Text className="mb-0">{review.desigination}</Text>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        </section>
    );
}